import { ChevronRightIcon } from '@zep-us/zus-icons';
import { Trans, useTranslation } from 'next-i18next';
import { Button } from '@zep/ui/experimental';
import { cn } from '@zep/utils';
import { CMS_CDN } from '../../../consts/env';
const NAVERZ_LOGO_URL = `${CMS_CDN}/medias/9z7bCJzn/t4E/6RvV03Wk87DV3cCmIc1nt4E/en-US/1/naverZ.webp`;
const SUPERCAT_LOGO_URL = `${CMS_CDN}/medias/9z7bCJzn/IX5/6S1sO3Wk87CV3cCmIb1uIX5/en-US/1/supercat.webp`;
export const LandingRecruitBanner = () => {
  const {
    t
  } = useTranslation(['home']);
  return <section className="flex w-full items-center justify-center bg-quiz-alternative px-quiz-md py-quiz-2xl tablet:px-quiz-2xl tablet:py-quiz-3xl" data-sentry-component="LandingRecruitBanner" data-sentry-source-file="LandingRecruitBanner.tsx">
      <div className="flex w-full max-w-screen-xl flex-col items-center gap-quiz-xl">
        <div className="flex w-full flex-col items-center gap-quiz-md">
          <div className="flex w-full items-start justify-center gap-quiz-xs tablet:gap-quiz-xl">
            <img src={NAVERZ_LOGO_URL} alt="NAVER Z" className="h-[52.7px] w-[175px] object-contain min-[560px]:h-[59px] min-[560px]:w-[196px] tablet:h-[72px] tablet:w-[239px]" />
            <img src={SUPERCAT_LOGO_URL} alt="SUPERCAT" className="h-[52.7px] w-[175px] object-contain min-[560px]:h-[59px] min-[560px]:w-[196px] tablet:h-[72px] tablet:w-[239px]" />
          </div>
          <p className="w-full whitespace-pre-line text-balance text-center text-quiz-body-lg-medium text-quiz-default">
            <Trans t={t} i18nKey="home:landing.recruit.description" components={{
            br: <br className="hidden tablet:inline" />
          }} data-sentry-element="Trans" data-sentry-source-file="LandingRecruitBanner.tsx" />
          </p>
        </div>

        <Button asChild variant="rounded" size="lg" className={cn('flex h-[48px] min-w-[142px] items-center justify-center gap-quiz-3xs', 'bg-quiz-strong text-quiz-inverse', 'hover:bg-quiz-primary-strong', 'px-quiz-md')} data-sentry-element="Button" data-sentry-source-file="LandingRecruitBanner.tsx">
          <a href="https://zep.career.greetinghr.com/ko/intro" target="_blank" rel="noopener noreferrer">
            {t('home:landing.recruit.button')}
            <ChevronRightIcon className="size-quiz-lg" data-sentry-element="ChevronRightIcon" data-sentry-source-file="LandingRecruitBanner.tsx" />
          </a>
        </Button>
      </div>
    </section>;
};